import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

const WIDTH = 22;
const HEIGHT = 2;

const HamburgerIcon = ({ isOpen }) => (
  <div className={classNames('HamburgerIcon', { 'HamburgerIcon--open': isOpen })}>
    <div className="HamburgerIcon__blocks" />
    <style jsx>
      {`
        .HamburgerIcon {
          padding: ${Theme.get('spacing') + HEIGHT}px 0;
        }

        .HamburgerIcon__blocks {
          display: block;
          height: ${HEIGHT}px;
          width: ${WIDTH}px;
          background-color: ${Theme.get('colors-black')};
          position: relative;
          transition: all ${Theme.get('transition-duration-fast-ms')};
        }

        .HamburgerIcon__blocks::before {
          content: '';
          position: absolute;
          top: -${Theme.get('spacing') + HEIGHT}px;
          left: 0;
          width: ${WIDTH}px;
          height: ${HEIGHT}px;
          background-color: ${Theme.get('colors-black')};
          transition: all ${Theme.get('transition-duration-fast-ms')};
        }

        .HamburgerIcon__blocks::after {
          content: '';
          position: absolute;
          top: ${Theme.get('spacing') + HEIGHT}px;
          left: 0;
          width: ${WIDTH}px;
          height: ${HEIGHT}px;
          background-color: ${Theme.get('colors-black')};
          transition: all ${Theme.get('transition-duration-fast-ms')};
        }

        .HamburgerIcon--open .HamburgerIcon__blocks {
          background-color: transparent;
        }

        .HamburgerIcon--open .HamburgerIcon__blocks::before {
          transform: rotate(45deg);
          top: 0;
        }

        .HamburgerIcon--open .HamburgerIcon__blocks::after {
          transform: rotate(-45deg);
          top: 0;
        }
      `}
    </style>
  </div>
);

HamburgerIcon.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default HamburgerIcon;
